





















import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
@Component({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currRatio:{
      default:'9:16'
    },
    title:{
      type:String,
      default:'选择效果'
    },
    confirmText:{
      type:String,
      default:'确定'
    },
    showClose: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.show = val
      },
      immediate: true
    }
  },
  components: {
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class PopupContainer extends Vue{
  [x: string]: any;
  state = new PageState();
  show = false;
  chooseEffect = '静态' ;
  effectList = [{idx:0,value:'静态',imgIcon:require('/public/images/video_editor/static_effect.png')},{idx:1,value:'微动',imgIcon:require('/public/images/video_editor/inching_effect.png')},{idx:2,value:'动画',imgIcon:require('/public/images/video_editor/animation_effect.png')}];
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  closePopup() {
    this.$emit('close')
  }
  /**
   * 确定
   */
  confirmChoose() {
    console.log('---确认选择')
    this.$emit('confirm')
  }
  submitRate(){
    this.$emit('changeEffect',this.chooseEffect)
    this.$emit('close')
  }
}
